import note from '@/plugins/i18n/en/pages/trial/note'
import optIn from '@/plugins/i18n/en/pages/trial/opt-in'
import registration from '@/plugins/i18n/en/pages/trial/registration'
import thankYou from '@/plugins/i18n/en/pages/trial/thank-you'

export default {
    note,
    optIn,
    registration,
    thankYou
}
